import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Mantine-Theme aus den Design-Tokens (D-M0 v1.2, Brief v2.0). Einzige Stelle
 * neben docs/design/tokens/, an der Hexwerte zulaessig sind (CI-Gate); die
 * Rampe spiegelt --wb-primary-50..900 (Mantine verlangt ein 10er-Array statt
 * CSS-Variablen fuer die Farbrampen).
 */
const indigo: MantineColorsTuple = [
  '#eef2ff', // 0 = 50 (Tint)
  '#e0e7ff', // 1 = 100
  '#c7d2fe', // 2 = 200
  '#a5b4fc', // 3 = 300
  '#818cf8', // 4 = 400
  '#6366f1', // 5 = 500
  '#4f46e5', // 6 = 600 (Basis)
  '#4338ca', // 7 = 700 (Hover)
  '#3730a3', // 8 = 800
  '#312e81', // 9 = 900
];

export const theme = createTheme({
  colors: { indigo },
  primaryColor: 'indigo',
  primaryShade: 6,
  defaultRadius: 8, // --wb-radius-control
  fontFamily: 'var(--wb-font-family)',
  fontFamilyMonospace: 'var(--wb-font-family-mono)',
  fontSizes: {
    xs: 'var(--wb-font-size-xs)',
    sm: 'var(--wb-font-size-sm)',
    md: 'var(--wb-font-size-md)',
    lg: 'var(--wb-font-size-lg)',
    xl: 'var(--wb-font-size-xl)',
  },
  spacing: {
    xs: 'var(--wb-space-xs)',
    sm: 'var(--wb-space-sm)',
    md: 'var(--wb-space-md)',
    lg: 'var(--wb-space-lg)',
    xl: 'var(--wb-space-xl)',
  },
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: 'var(--wb-font-size-h1)', lineHeight: '1.2' }, // Seitentitel 24
      h2: { fontSize: 'var(--wb-font-size-h1)', lineHeight: '1.2' }, // Seitentitel-Muster
      h3: { fontSize: 'var(--wb-font-size-xl)', lineHeight: '1.25' }, // Abschnitt 18
      h4: { fontSize: 'var(--wb-font-size-lg)', lineHeight: '1.3' }, // Kartentitel 16
    },
  },
  components: {
    // Feldbeschreibungen UNTER dem Eingabefeld (2026-08): der Mantine-Default
    // (Beschreibung zwischen Label und Feld) schiebt die Felder benachbarter
    // Formularspalten auf unterschiedliche Hoehen.
    InputWrapper: {
      defaultProps: { inputWrapperOrder: ['label', 'input', 'description', 'error'] },
    },
    Badge: {
      defaultProps: { radius: 'xl' }, // Pills
    },
    Button: {
      defaultProps: { radius: 8 },
    },
    Paper: {
      defaultProps: { radius: 16 },
    },
    Card: {
      // Kartenpadding 20 (Brief §5 "klein"; K1 D7-Audit); große Karten
      // setzen padding 24 explizit.
      defaultProps: { radius: 16, padding: 20 },
    },
    Table: {
      defaultProps: { verticalSpacing: 'sm' },
    },
    Modal: {
      defaultProps: {
        radius: 16,
        shadow: 'var(--wb-shadow-md)',
        transitionProps: { transition: 'slide-up', duration: 180 },
        overlayProps: { opacity: 0.35, blur: 1 },
      },
    },
    Menu: {
      defaultProps: {
        radius: 12,
        shadow: 'var(--wb-shadow-md)',
        transitionProps: { transition: 'fade', duration: 140 },
      },
    },
    Tooltip: {
      defaultProps: { transitionProps: { transition: 'fade', duration: 140 } },
    },
    Alert: {
      defaultProps: { radius: 12 },
    },
    Skeleton: {
      defaultProps: { radius: 8 },
    },
  },
});
